var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.isAccessGranted
        ? _c("Badge", {
            attrs: {
              color: _vm.BadgeColor.SUCCESS,
              value: "Access Granted",
              size: "lg",
            },
          })
        : _vm._e(),
      _vm.isContractorRequested
        ? _c("Badge", {
            attrs: {
              color: _vm.BadgeColor.OUTLINE,
              value: "Requested",
              size: "lg",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }